import React from 'react';
import { Box } from '@chakra-ui/react';

import StatusButton from '../../../../../../../../../../../components/StatusButton';
import { getStatusButtonMenuOptions } from '../../../../../../../../../../../components/StatusButton/reactQueryUtil';
import { CypressIds } from '../../../../../../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../../../../../../constants/duskIds';
import { useArchiveDocument, useDeleteDocument, useReactivateDocument } from '../../../../../../../../../../../services/document-service';

export const COLUMNS = [
  {
    Header: 'Document Type',
    accessor: 'insuranceDocumentType.displayName',
    Cell: ({ cell: { value }, row: { original } }) => (
      <Box data-cy={CypressIds.archivedDocumentRow(original.id)}>{value}</Box>
    )
  },
  {
    Header: 'Document Name',
    accessor: 'displayName',
    Cell: ({ row: { original } }) => original.displayName || original.originalName
  },
  {
    Header: 'Upload Date',
    accessor: 'uploaded',
    Cell: ({ row: { original } }) => original.createdAt.split('T')[0]
  },
  {
    Header: 'Options',
    accessor: 'status',
    Cell: ({ cell: { value }, row: { original } }) => {
      const { recordId, id: docId, insurableId: insuredId, jobId, insuranceDocumentTypeId: docTypeId } = original;

      const { mutate: archiveDocument } = useArchiveDocument({ docId, insuredId, recordId, docTypeId });
      const { mutate: reactivateDocument } = useReactivateDocument({ docId, insuredId, recordId, docTypeId });
      const { mutate: deleteDocument } = useDeleteDocument({ docId, insuredId, recordId, docTypeId });

      const options = getStatusButtonMenuOptions(value, 'documents');

      return (
        <StatusButton
          cypressId={CypressIds.archivedDocumentRowStatusButton(original.id)}
          duskSelector={InsuredProfilePageDuskIds.getArchivedDocumentStatusButton(original.id)}
          id={original.id}
          metadata={{
            documentId: original.id,
            archiveDocument,
            reactivateDocument,
            deleteDocument
          }}
          options={options}
        />
      );
    }
  }
];
